import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    TextField,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    MenuItem,
    TablePagination
} from "@mui/material";

import { Visibility, Edit, Delete } from "@mui/icons-material";

import {
    collection,
    getDocs,
    addDoc,
    updateDoc,
    deleteDoc,
    doc,
    Timestamp
} from "firebase/firestore";

import { db } from "../../firebase";

function Dealeraccount() {

    const [dealers, setDealers] = useState([])
    const [purchases, setPurchases] = useState([])
    const [payments, setPayments] = useState([])
    const [payModes, setPayModes] = useState([])

    const [search, setSearch] = useState("")
    const [page, setPage] = useState(0)
    const rowsPerPage = 10

    const [openHistory, setOpenHistory] = useState(false)
    const [selectedDealer, setSelectedDealer] = useState(null)
    const [dealerPayments, setDealerPayments] = useState([])

    const [openPayment, setOpenPayment] = useState(false)
    const [editPaymentId, setEditPaymentId] = useState(null)

    const [paymentForm, setPaymentForm] = useState({
        amount: "",
        paymentMode: "",
        purchaseId: "",
        note: "",
        date: ""
    })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = async () => {

        const dealerSnap = await getDocs(collection(db, "dealers"))
        const purchaseSnap = await getDocs(collection(db, "purchases"))
        const paymentSnap = await getDocs(collection(db, "dealerPayments"))
        const paymodeSnap = await getDocs(collection(db, "payment_modes"))

        setDealers(dealerSnap.docs.map(d => ({ id: d.id, ...d.data() })))
        setPurchases(purchaseSnap.docs.map(d => ({ id: d.id, ...d.data() })))
        setPayments(paymentSnap.docs.map(d => ({ id: d.id, ...d.data() })))
        setPayModes(paymodeSnap.docs.map(d => ({ id: d.id, ...d.data() })))

    }

    const getDealerTotalPurchase = (dealerId) => {

        return purchases
            .filter(p => p.dealerId === dealerId)
            .reduce((sum, p) => sum + Number(p.grandtotal || 0), 0)

    }

    const reloadDealerPayments = async (dealerId) => {
        const paymentSnap = await getDocs(collection(db, "dealerPayments"));
        const allPayments = paymentSnap.docs.map(d => ({ id: d.id, ...d.data() }));

        setPayments(allPayments);

        const history = allPayments
            .filter(p => p.dealerId === dealerId)
            .sort((a, b) => (b.date?.toDate ? b.date.toDate() : 0) - (a.date?.toDate ? a.date.toDate() : 0));

        setDealerPayments(history);
    };

    const getDealerTotalPaid = (dealerId) => {

        return payments
            .filter(p => p.dealerId === dealerId)
            .reduce((sum, p) => sum + Number(p.amount || 0), 0)

    }

    const getPaymentMode = (id) => {

        const mode = payModes.find(m => m.id === id);

        return mode ? mode.payMode : ""

    }

    const handleView = (dealer) => {
        const history = payments
            .filter(p => p.dealerId === dealer.id)
            .sort((a, b) => (b.date?.toDate ? b.date.toDate() : 0) - (a.date?.toDate ? a.date.toDate() : 0));

        setSelectedDealer(dealer)
        setDealerPayments(history)
        setOpenHistory(true)
    }

    const handleSavePayment = async () => {

        const data = {
            ...paymentForm,
            dealerId: selectedDealer.id,
            date: Timestamp.fromDate(new Date(paymentForm.date))
        }

        if (editPaymentId) {

            await updateDoc(doc(db, "dealerPayments", editPaymentId), data)

        } else {

            await addDoc(collection(db, "dealerPayments"), data)

        }

        setOpenPayment(false)

        await reloadDealerPayments(selectedDealer.id)

    }
    const handleDeletePayment = async (id) => {

        await deleteDoc(doc(db, "dealerPayments", id))
        await reloadDealerPayments(selectedDealer.id)

    }

    const filtered = dealers.filter(d =>
        d.dealerName?.toLowerCase().includes(search.toLowerCase())
    )

    return (

        <Box p={2}>

            <Typography variant="h5" fontWeight="bold" mb={2}>
                Dealer Accounts
            </Typography>

            <TextField
                size="small"
                placeholder="Search Dealer"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                sx={{ mb: 2 }}
            />

            <Paper>

                <Table size="small">

                    <TableHead sx={{ background: "#f5f5f5" }}>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Dealer Name</TableCell>
                            <TableCell style={{textAlign:"right"}}>Total Purchase</TableCell>
                            <TableCell style={{textAlign:"right"}}>Total Paid</TableCell>
                            <TableCell style={{textAlign:"right"}}>Remaining</TableCell>
                            <TableCell align="center">Action</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>

                        {filtered
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((dealer, index) => {

                                const totalPurchase = getDealerTotalPurchase(dealer.id)
                                const totalPaid = getDealerTotalPaid(dealer.id)
                                const remaining = parseFloat(totalPurchase) - parseFloat(totalPaid)

                                return (

                                    <TableRow key={dealer.id} hover>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{dealer.dealerName}</TableCell>
                                        <TableCell style={{textAlign:"right"}}>{totalPurchase.toFixed(0)}</TableCell>
                                        <TableCell style={{textAlign:"right"}}>{totalPaid.toFixed(0)}</TableCell>
                                        <TableCell style={{textAlign:"right"}}>{remaining.toFixed(2)}</TableCell>
                                        <TableCell align="center">
                                            <IconButton
                                                color="primary"
                                                onClick={() => handleView(dealer)}
                                            >
                                                <Visibility />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                    </TableBody>
                </Table>

                <TablePagination
                    rowsPerPageOptions={[10]}
                    component="div"
                    count={filtered.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={(e, newPage) => setPage(newPage)}
                />

            </Paper>

            {/* Payment History */}

            <Dialog open={openHistory} fullWidth maxWidth="md">

                <DialogTitle
                    sx={{ display: "flex", justifyContent: "space-between" }}
                >

                    Payment History - {selectedDealer?.dealerName}

                    <Button
                        variant="contained"
                        size="small"
                        onClick={() => {

                            setEditPaymentId(null)

                            setPaymentForm({
                                amount: "",
                                paymentMode: "",
                                purchaseId: "",
                                note: "",
                                date: new Date().toISOString().split("T")[0]
                            })

                            setOpenPayment(true)

                        }}
                    >
                        Add Payment
                    </Button>

                </DialogTitle>

                <DialogContent>

                    <Table size="small">

                        <TableHead sx={{ background: "#f5f5f5" }}>
                            <TableRow>
                                <TableCell>Date</TableCell>
                                <TableCell>Note</TableCell>
                                <TableCell>Mode</TableCell>
                                <TableCell>Amount</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {dealerPayments
                                .sort((a, b) => {
                                    const dateA = a.date?.toDate ? a.date.toDate() : new Date(a.date);
                                    const dateB = b.date?.toDate ? b.date.toDate() : new Date(b.date);
                                    return dateB - dateA; // Descending order (Newest first)
                                })
                                .map((p) => (
                                    <TableRow key={p.id}>
                                        <TableCell>
                                            {p.date?.toDate
                                                ? p.date.toDate().toLocaleDateString()
                                                : ""}
                                        </TableCell>
                                        {/* ... rest of your TableCells ... */}
                                        <TableCell>{p.note || "-"}</TableCell>
                                        <TableCell>{getPaymentMode(p.paymentMode)}</TableCell>
                                        <TableCell>{p.amount}</TableCell>
                                        <TableCell>
                                            <IconButton color="primary" onClick={() => {
                                                setEditPaymentId(p.id)
                                                setPaymentForm({
                                                    amount: p.amount,
                                                    paymentMode: p.paymentMode,
                                                    purchaseId: p.purchaseId,
                                                    note: p.note || "",
                                                    date: p.date?.toDate().toISOString().split("T")[0]
                                                })
                                                setOpenPayment(true)
                                            }}
                                            >
                                                <Edit />
                                            </IconButton>

                                            <IconButton
                                                color="error"
                                                onClick={() => handleDeletePayment(p.id)}
                                            >
                                                <Delete />
                                            </IconButton>

                                        </TableCell>
                                    </TableRow>
                                ))
                            }
                        </TableBody>

                    </Table>

                </DialogContent>

                <DialogActions>

                    <Button onClick={() => setOpenHistory(false)}>
                        Close
                    </Button>

                </DialogActions>

            </Dialog>

            {/* Add / Edit Payment */}

            <Dialog open={openPayment} maxWidth="sm" fullWidth>

                <DialogTitle>
                    {editPaymentId ? "Edit Payment" : "Add Payment"}
                </DialogTitle>

                <DialogContent>

                    <TextField
                        label="Date"
                        type="date"
                        fullWidth
                        size="small"
                        sx={{ mt: 2 }}
                        InputLabelProps={{ shrink: true }}
                        value={paymentForm.date}
                        onChange={(e) => setPaymentForm({ ...paymentForm, date: e.target.value })}
                    />

                    <TextField
                        label="Amount"
                        fullWidth
                        size="small"
                        sx={{ mt: 2 }}
                        value={paymentForm.amount}
                        onChange={(e) => setPaymentForm({ ...paymentForm, amount: e.target.value })}
                    />

                    <TextField
                        select
                        label="Purchase"
                        fullWidth
                        size="small"
                        sx={{ mt: 2 }}
                        value={paymentForm.purchaseId}
                        onChange={(e) => setPaymentForm({ ...paymentForm, purchaseId: e.target.value })}
                    >

                        {purchases
                            .filter(p => p.dealerId === selectedDealer?.id)
                            .map(p => (
                                <MenuItem key={p.id} value={p.id}>
                                    {p.purchaseno}
                                </MenuItem>
                            ))}

                    </TextField>

                    <TextField
                        select
                        label="Payment Mode"
                        fullWidth
                        size="small"
                        sx={{ mt: 2 }}
                        value={paymentForm.paymentMode}
                        onChange={(e) => setPaymentForm({ ...paymentForm, paymentMode: e.target.value })}
                    >

                        {payModes.map(m => (
                            <MenuItem key={m.id} value={m.id}>
                                {m.payMode}
                            </MenuItem>
                        ))}

                    </TextField>

                    <TextField
                        label="Note"
                        fullWidth
                        size="small"
                        sx={{ mt: 2 }}
                        value={paymentForm.note}
                        onChange={(e) => setPaymentForm({ ...paymentForm, note: e.target.value })}
                    />

                </DialogContent>

                <DialogActions>

                    <Button onClick={() => setOpenPayment(false)}>
                        Cancel
                    </Button>

                    <Button variant="contained" onClick={handleSavePayment}>
                        Save
                    </Button>

                </DialogActions>

            </Dialog>

        </Box>

    )

}

export default Dealeraccount